import { compose, createStore, applyMiddleware, combineReducers } from 'redux'
import createSagaMiddleware from 'redux-saga'

import { reducer as AuthReducer } from 'store/models/auth'
import { reducer as SupplierReducer } from 'store/models/supplier'
import { reducer as TransactionsReducer } from 'store/models/transactions'
import { reducer as TicketsReducer } from 'store/models/tickets'
import { reducer as ResourcesReducer } from 'store/models/resources'
import { reducer as FinanceReducer } from './models/finance'
import { reducer as ManagersReducer } from './models/managers'
import { reducer as VouchersReducer } from './models/vouchers'

const rootReducer = combineReducers({
    auth: AuthReducer,
    supplier: SupplierReducer,
    transactions: TransactionsReducer,
    tickets: TicketsReducer,
    resources: ResourcesReducer,
    finance: FinanceReducer,
    managers: ManagersReducer,
    vouchers: VouchersReducer,
})

const defaultReducer = (state, action) => {
    if (action.type === 'LOG_OUT') {
        state = undefined
    }
    return rootReducer(state, action)
}

export default function configureStore() {
    const sagaMiddleware = createSagaMiddleware()

    const loggerMiddleware = store => next => action => {
        const returnValue = next(action)

        if (console.group) {
            // console.group(action.type);
            // console.log("%c action", "color: #03A9F4", action);
            // console.log("%c newState", "color: #03A9F4", store.getState());
            // console.groupEnd();
        }
        return returnValue
    }

    const enhancers = []
    const middlewares = [sagaMiddleware, loggerMiddleware]

    if (process.env.NODE_ENV === 'development') {
        const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

        if (typeof devToolsExtension === 'function') {
            enhancers.push(devToolsExtension())
        }
    }

    const composedEnhancers = compose(applyMiddleware(...middlewares), ...enhancers)

    return {
        ...createStore(defaultReducer, composedEnhancers),
        runSaga: sagaMiddleware.run,
    }
}
